import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import parse from 'html-react-parser';

import NoticeInfo from './NoticeInfo';

import FetchModule from '../../Share/Network/FetchModule';

const NoticeList = (props) => {
  const { data, isOver } = props;

  const history = useHistory();

  function clickDetailsFn(index) {
    // console.log(data[index]);
    history.push('/notice/details/' + data[index].noticeId);
  }
  
  return (
    <TopLevelWrapper isOver={isOver}>
      <TotalView isOver={isOver}>
        {
          data.map((data, index) => (
            <NoticeInfo key={index} data={data} index={index} isOver={isOver} clickFn={clickDetailsFn}/>
          ))
        }
      </TotalView>
    </TopLevelWrapper>
  )
}

export default NoticeList;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: ${props => props.isOver ? `max(692px, 90.10416666666667vw)` : `max(298px, 93.125vw)`};
  min-height: ${props => props.isOver ? `428px` : `321px`}; // 321

  margin-top: ${props => props.isOver ? `28px` : `16px`};
  margin-bottom: 44px;

  border-radius: 30px;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const TotalView = styled.div`
  display: flex;
  flex-direction: column;

  // justify-content: flex-start;
  // align-items: flex-start;

  justify-content: flex-start;
  align-items: center;

  gap: ${props => props.isOver ? `4px` : `3px`};
  margin-top: 24px;
  margin-bottom: 24px; 

  width: ${props => props.isOver ? `max(652px, 84.89583333333333vw)` : `max(278px, 86.875vw)`};
  height: ${props => props.isOver ? `380px` : `273px`};
`;
